export class Clock {
  private last = performance.now();
  private readonly maxStep = 1 / 15;

  reset(): void {
    this.last = performance.now();
  }

  step(): number {
    const now = performance.now();
    const dt = (now - this.last) / 1000;
    this.last = now;
    return Math.min(dt, this.maxStep);
  }
}
